import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CheckBoxInput,
  CheckboxOption,
  InformationBox,
  NavigationButtons,
} from '@molecules/*';
import { RoutesList } from '@animal-nuisance/routes/Routes';
import {
  issueTypes,
  issueTypeInfo,
} from '@animal-nuisance/constants/questionData';
import { useAnimalNuisanceStore } from '@animal-nuisance/hooks/useAnimalNuisanceStore';
import { issueTypeSchema } from '../../validations';
import { ErrorMessages } from '@types';
import { parseZodErrors } from '@utils';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/*';

const initialData: CheckboxOption[] = issueTypes;

export const IssueTypePage: React.FC = () => {
  const {
    data: { issueTypes },
    update,
  } = useAnimalNuisanceStore();
  const navigate = useNavigate();

  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const handleChange = (selected: CheckboxOption[]) => {
    update('issueTypes', selected);
    setErrorMessages([]);
  };

  const handleNext = () => {
    issueTypes?.some((type) => type.name === 'Noise');
    try {
      const getIssueTypes = issueTypes.map((issue) => issue.name);
      issueTypeSchema.parse({
        issueTypes: getIssueTypes,
      });
      navigate(RoutesList.DESCRIBE_THE_ISSUE);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.REPORT_TYPE),
  };

  const checkType = (key: string) => {
    return !!issueTypes?.find((type) => type?.name === key);
  };

  return (
    <div className="p-4">
      <ErrorSummary messages={errorMessages} />
      <CheckBoxInput
        title="Select a type of issue"
        description="Select all that apply"
        options={initialData?.map((option) => ({
          ...option,
          checked: issueTypes?.some(
            (issueType) => issueType?.id === option?.id,
          ),
        }))}
        maxOptions={6}
        onChange={handleChange}
        errorPath="issueTypes"
        errorMessages={errorMessages}
      />

      {checkType('AggressiveDog') ? (
        <div className="mb-5">
          <InformationBox
            infoText={issueTypeInfo['AggressiveDog']}
            variant="info"
            title=""
          />
        </div>
      ) : null}
      {checkType('AnimalWelfare') ? (
        <div className="mb-5">
          <InformationBox
            infoText={issueTypeInfo['AnimalWelfare']}
            variant="info"
            title=""
          />
        </div>
      ) : null}
      {checkType('BarkingDog') ? (
        <div className="mb-5">
          <InformationBox
            infoText={issueTypeInfo['BarkingDog']}
            variant="info"
            title=""
          />
        </div>
      ) : null}

      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </div>
  );
};
